import {Input} from '@cashiaApp/web-components';
import React from 'react';

interface CheckoutBaseFieldsProps {
  requestId: string;
  amount: number;
  currency: string;
  onChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
  renderErrorMessage: (fieldName: string) => React.ReactNode;
}

/**
 * CheckoutBaseFields Component
 *
 * Reusable component containing the core checkout form fields:
 * - Amount
 * - Currency
 * - Request ID
 *
 * @example
 * ```tsx
 * <CheckoutBaseFields
 *   amount={values.amount}
 *   currency={values.currency}
 *   requestId={values.requestId}
 *   onChange={handleChange}
 *   renderErrorMessage={renderErrorMessage}
 * />
 * ```
 */
export const CheckoutBaseFields: React.FC<CheckoutBaseFieldsProps> = ({
  requestId,
  amount,
  currency,
  onChange,
  renderErrorMessage,
}) => {
  return (
    <>
      {/* Request ID Field */}
      <div className="my-1">
        <label className="text-darkGrey text-sm font-bold mb-1 flex gap-2 items-center">
          RequestId * {renderErrorMessage('requestId')}
        </label>
        <Input
          name="requestId"
          value={requestId}
          onChange={onChange}
          placeholder="Unique request identifier"
          className="w-full bg-transparent rounded-lg h-12 focus:ring-2 focus-visible:border-none focus:ring-[#FECED8]"
        />
      </div>
      {/* Amount Field */}
      <div className="my-1">
        <label className="text-darkGrey flex gap-2 items-center text-sm font-bold mb-1">
          Amount * {renderErrorMessage('amount')}
        </label>
        <Input
          name="amount"
          type="number"
          value={amount}
          onChange={onChange}
          placeholder="Enter amount"
          className="w-full bg-transparent rounded-lg h-12 focus:ring-2 focus-visible:border-none focus:ring-[#FECED8]"
        />
      </div>

      {/* Currency Field */}
      <div className="my-1">
        <label className="text-darkGrey text-sm font-bold mb-1 flex gap-2 items-center">
          Currency * {renderErrorMessage('currency')}
        </label>
        <Input
          name="currency"
          value={currency}
          onChange={onChange}
          placeholder="e.g., KES, USD"
          className="w-full bg-transparent rounded-lg h-12 focus:ring-2 focus-visible:border-none focus:ring-[#FECED8]"
        />
      </div>
    </>
  );
};
